import { useState } from 'react';
import MobileSidebar from './MobileSidebar';
import DesktopSidebar from './DesktopSidebar';
import Navbar from '../NavBar';
import { useAuth } from '../../atoms';
import './styles.css';
import { useBreakpoints } from '@jobcost-monorepo/utils';

type Props = {
  children?: React.ReactNode;
};

const SidebarLayout: React.FC<Props> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [sidebarWidth, setSidebarWidth] = useState<number>(0);
  const { isSmall } = useBreakpoints();
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMIN';

  return (
    <div className="flex flex-row h-[calc(100dvh)] w-[100vw]">
      {isAdmin && (
        <>
          <MobileSidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
          <DesktopSidebar setSidebarWidth={setSidebarWidth} />
        </>
      )}

      <div className="size-full">
        <Navbar setSidebarOpen={setSidebarOpen} />
        <main
          className="flex flex-col overflow-y-auto h-[calc(100dvh-55px)]"
          style={{
            width: isSmall ? '100vw' : `calc(100vw - ${sidebarWidth}px)`,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default SidebarLayout;
